import { render, staticRenderFns } from "./messageDialog3.vue?vue&type=template&id=bb929320&scoped=true&"
import script from "./messageDialog3.vue?vue&type=script&lang=js&"
export * from "./messageDialog3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb929320",
  null
  
)

export default component.exports